import axios from "axios";

/**
 * Cliente para local_tipddy_activity_get_log (plugin local_tipddy_activity).
 * A diferencia de ranking.js, la base de Moodle se recibe por parámetro
 * (config.baseURL) en vez de quedar hardcodeada a producción.
 */
export const getActivityLog = async ({
  token,
  baseUrl,
  userid = 0,
  courseid = 0,
  limit = 20,
  offset = 0,
}) => {
  const search = new URLSearchParams({
    wstoken: token,
    moodlewsrestformat: "json",
    wsfunction: "local_tipddy_activity_get_log",
    userid,
    courseid,
    limit,
    offset,
  });

  const { data } = await axios.get(
    `${baseUrl.replace(/\/$/, "")}/webservice/rest/server.php?${search.toString()}`
  );

  if (data && data.exception) {
    throw new Error(data.message || data.errorcode || "Moodle web service error");
  }

  return data;
};
